class KlaviyoCustomTrigger {
    init() {
        this.handleKlaviyoBackInStockButtonCustomTrigger()
    }

    handleKlaviyoBackInStockButtonCustomTrigger() {
        document.querySelector('.klaviyo_form_trigger').addEventListener('click', () => {
            window._klOnsite = window._klOnsite || [];
            window._klOnsite.push(['openForm', 'XYx3rH']);
        });
    }
}

new KlaviyoCustomTrigger().init()
